import axios from "axios";
import keycloak from "@/config/keycloak";

const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
});

api.interceptors.request.use(async (config) => {
  try {
    const urlParams = new URLSearchParams(globalThis.location.search);
    const assignmentId = urlParams.get("id");

    if (assignmentId) {
      // Responder request
      config.headers["Assignment-ID"] = assignmentId;
      
      // Add responder token if available
      const responderToken = localStorage.getItem("responder_auth_token");
      if (responderToken) {
        config.headers.Authorization = `Bearer ${responderToken}`;
      }
    } else if (keycloak.idToken) {
      // Admin request
      // Try to update token if it's about to expire
      await keycloak.updateToken(5).catch(() => {
        console.error("Failed to refresh token (idToken) in interceptor");
      });
      config.headers.Authorization = `Bearer ${keycloak.idToken}`;
    }
  } catch (error) {
    if (!globalThis.location.pathname.startsWith("/responder")) {
      console.error("Session invalid context:", error);
    }
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      if (!globalThis.location.pathname.startsWith("/responder")) {
        console.error("API Error: status", error.response?.status, "URL:", error.config?.url);
        console.error("Authentication error detected, but avoiding automatic logout as per request.");
      }
    }
    throw error;
  }
);

export default api;
